import React, { useContext } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Modal } from "@material-ui/core/";
import EmailForm from "./EmailForm";
import Markdown from "../../Markdown";
import { TextContext } from "@pages/bereken-bijdrage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
    },
    paper: {
      position: "absolute",
      maxWidth: 450,
      minWidth: 250,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      border: "none",
      padding: theme.spacing(3, 3, 3),
      outline: "none",
      borderRadius: "4px",
    },
  })
);
//onsubmit: check als echte mail, close modal en popup succesvol
type EmailModalProps = {
  handleCloseModal: any;
  openModal: any;
  onSubmitEmail: any;
  handleSubmit: any;
  register: any;
  getValues: any;
  errors: any;
};
const EmailModal = (props: EmailModalProps) => {
  const handleClose = props.handleCloseModal;
  const openModal = props.openModal;
  const classes = useStyles();
  const text = useContext(TextContext);
  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <div className={classes.paper}>
          <Markdown style={{ marginBottom: "15px" }}>{text.emailModalText}</Markdown>
          <EmailForm onSubmitEmail={props.onSubmitEmail} />
        </div>
      </Modal>
    </div>
  );
};

export default EmailModal;
